"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType[ActionType["DoNothing"] = 1] = "DoNothing";
    ActionType[ActionType["UseAbility"] = 2] = "UseAbility";
    ActionType[ActionType["EnterRoom"] = 3] = "EnterRoom";
    ActionType[ActionType["AddActor"] = 5] = "AddActor";
    ActionType[ActionType["CancelEventHandler"] = 6] = "CancelEventHandler";
    ActionType[ActionType["ClearRoom"] = 7] = "ClearRoom";
    ActionType[ActionType["FailRoom"] = 8] = "FailRoom";
    ActionType[ActionType["ExitRoom"] = 9] = "ExitRoom";
    ActionType[ActionType["FailAdventure"] = 10] = "FailAdventure";
    ActionType[ActionType["SpeakText"] = 11] = "SpeakText";
    ActionType[ActionType["ApplyEffect"] = 12] = "ApplyEffect";
    ActionType[ActionType["RemoveRandomDebuff"] = 13] = "RemoveRandomDebuff";
    ActionType[ActionType["UseAbilityOnRandomEnemy"] = 14] = "UseAbilityOnRandomEnemy";
    ActionType[ActionType["UseAbilityOnTarget"] = 15] = "UseAbilityOnTarget";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
